import { defineStore } from 'pinia'
import { useDateMiddleware } from '#imports'

export const useCustomStore = () =>
  defineStore('custom-store', () => {
    const getData = async (affix, params) => {
      let parameters = ''
      if (params) {
        const paramArray = Array.isArray(params) ? params : [params]
        const query = paramArray
          .map(
            (p) =>
              `${encodeURIComponent(p.name)}=${encodeURIComponent(p.value)}`
          )
          .join('&')
        parameters = `?${query}`
      }

      try {
        const response = await useApi(`api/${affix}/${parameters}`, {
          method: 'GET',
        })
        return response?.data
      } catch (error) {
        console.error('Failed to fetch data:', error)
      }
    }

    const getFilteredData = async (affix, filters) => {
      const query = Object.entries(filters)
        .map(
          ([key, value]) =>
            `filter[${encodeURIComponent(key)}]=${encodeURIComponent(
              String(value)
            )}`
        )
        .join('&')
      const url = query ? `api/${affix}?${query}` : `api/${affix}`

      try {
        const response = await useApi(url, { method: 'GET' })
        return response?.data
      } catch (error) {
        console.error('Failed to fetch filtered data:', error)
      }
    }

    const read = async (affix, param) => {
      const parameters = `${param.value}`
      try {
        const response = await useApi('api/' + affix + '/' + parameters, {
          method: 'GET',
        })
        return response?.data
      } catch (error) {
        console.error('Failed to fetch contacts:', error)
      }
    }

    const readCustom = async (affix, params) => {
      try {
        const query = new URLSearchParams(
          Object.entries(params).reduce((acc, [key, value]) => {
            acc[key] = String(value)
            return acc
          }, {})
        ).toString()

        const url = query ? `api/${affix}?${query}` : `api/${affix}`

        const response = await useApi(url, { method: 'GET' })
        return response?.data
      } catch (error) {
        console.error('❌ Failed to fetch data:', error)
        return null
      }
    }

    const update = async (affix, data, uuid) => {
      const uuidStr = uuid ? uuid : ''
      try {
        const response = await useApi('api/' + affix + '/' + uuidStr, {
          method: 'PUT',
          body: data,
        })
        return response?.data
      } catch (error) {
        console.error('Failed to fetch contacts:', error)
      }
    }

    const create = async (affix, data) => {
      try {
        const response = await useApi('api/' + affix + '/', {
          method: 'POST',
          body: data,
        })
        return response?.data
      } catch (error) {
        console.error('Failed to fetch contacts:', error)
      }
    }

    const store = { getData, getFilteredData, read, readCustom, update, create }
    const storeWithDates = useDateMiddleware(store, [
      'date',
      'startAt',
      'endAt',
    ])

    return storeWithDates
  })()
